export default "__VITE_ASSET__CEg9LQoy__"